import isString from 'lodash/isString'

class FitStep {
  constructor(args = {}) {
    if (!isString(args.id)) throw new Error('FitSteps must have a "id" property of type `string`')
    if (!isString(args.slug))
      throw new Error('FitSteps must have a "slug" property of type `string`')
    if (!isString(args.seoDescription)) {
      throw new Error('FitSteps must have a "seoDescription" property of type `string`')
    }
    if (!isString(args.seoTitle))
      throw new Error('FitSteps must have a "seoTitle" property of type `string`')

    Object.assign(this, args)

    if (!this.validate) {
      this.validate = () => {}
    }
  }
}

export default FitStep
